import { applyThemeVariant, DEFAULT_THEME_VARIANT, THEME_VARIANT_IDS } from "../../design-system/v2/foundations/themes";
import { bootUiScale } from "../../design-system/v2/foundations/uiScale";

// Démarrage du thème V2 sans l'index du design system : le squelette du bundle
// principal applique le thème et l'échelle choisis AVANT sa première peinture —
// sinon le premier écran sortait dans les couleurs par défaut.
export const THEME_VARIANT_STORAGE_KEY = "akV2ThemeVariant";

export const readStoredThemeVariant = (storage = typeof window !== "undefined" ? window.localStorage : null) => {
  try {
    const value = storage?.getItem?.(THEME_VARIANT_STORAGE_KEY);
    return THEME_VARIANT_IDS.includes(value) ? value : DEFAULT_THEME_VARIANT;
  } catch (_) {
    return DEFAULT_THEME_VARIANT;
  }
};

// À appeler avant de peindre une surface V2 : applique thème ET échelle stockés.
export const bootThemeVariant = () => {
  bootUiScale();
  return applyThemeVariant(readStoredThemeVariant());
};
